import { theme } from "@style/theme";
import styled from "styled-components";

export const ThirdPartyInfoStyle = styled.div`
    margin-left: 10px;
    
    & > div {
        font-size: 1em; 
        margin-bottom: 8px;

        & > span {
            font-weight: 500;
        }
    }
`;

export const ThirdPartyInfoTypeTitle = styled.h2`
    color:${theme.primary};
    font-size: 1em;
    margin-bottom: 8px !important;
`;
